import { ArrowLeftOutlined } from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import VerificationCode from '../../../components/Form/VerificationCode/VerificationCode';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Description = styled.p`
  font-size: 16px;
  color: #a6b0cf;
  margin: 10px 0px 20px 45px;
`;

const PhoneLink = styled(Link)`
  color: #397cf3;
  text-decoration: none;
  font-size: 17px;
`;

const IconArrowLeftOutlined = styled(ArrowLeftOutlined)`
  font-size: 16px;
  color: black;
  margin-right: 20px;
`;

const Verification = ({
  confirmOTP,
  phone,
  setOtp,
  setPage,
  otp,
  error,
  setError,
  isLoading,
  isResendCodeLoading,
  resendCode,
}) => {
  const arrowBack = () => {
    setPage('phone');
    setError(false);
  };

  return (
    <Container>
      <h3>
        <button className="arrow" type="button" onClick={arrowBack}>
          <IconArrowLeftOutlined />
        </button>
        Verification Code
      </h3>
      <Description>
        Enter the 6-digit code that we sent by SMS to the number
        <PhoneLink to="/"> {phone} </PhoneLink>
      </Description>
      <form onSubmit={confirmOTP}>
        <VerificationCode
          setOtp={setOtp}
          error={error}
          setError={setError}
          otp={otp}
          phone={phone}
          isLoading={isLoading}
          isResendCodeLoading={isResendCodeLoading}
          resendCode={resendCode}
        />
      </form>
    </Container>
  );
};

export default Verification;
